const SignupText = {
  headerText: 'We noticed you don\'t have a Google account connected.',
  subHeaderText: 'The email provided does not appear to be associated with a current organization.',
  createNewOrg: 'Creating your JumpCloud account.',
};

export default {
  SignupText,
};
